import React, { FC, useState } from "react";
import { AckErrorMessage, AckLoader, AckTable, AckTableRowProps, ModelSpec, useFetch } from "ackbox-weblib-react";
import { Empty, RESOURCES_API_PATH, useEffectOnce } from "./Constants";
import { Progress, useProgress } from "./Progress";

const ChangelogsSummary = () => {
  const [data, setData] = useState([] as any[]);
  const ackFetch = useFetch(RESOURCES_API_PATH);

  const { errors, isLoading } = useEffectOnce(async () => {
    const data = await ackFetch.get("changelogs/?pageId=0&pageSize=20");
    setData(data);
  });

  const OverallSummary: FC = () => {
    const spec: ModelSpec[] = [
      { key: "createdAt", label: "CreatedAt", name: "createdAt", type: "datetime-local" },
      { key: "action", label: "Action", name: "action", type: "text" },
      { key: "type", label: "Type", name: "type", type: "text" },
      { key: "data", label: "Data", name: "data", type: "text" },
    ];
    const rows: AckTableRowProps[] = data.map((summary: any) => ({ spec: spec, payload: summary }));
    return (<AckTable rows={rows}/>);
  };

  return (
    <>
      <AckErrorMessage errors={errors}/>
      <AckLoader isLoading={isLoading}/>
      {!isLoading && data.length > 0 && <OverallSummary/>}
      {!isLoading && data.length === 0 && <Empty/>}
    </>
  );
};

export const Changelogs = () => {
  const progress = useProgress();
  return (
    <div className="section">
      <h1 className="title is-spaced">Changelogs</h1>
      {!progress.isComplete && <Progress {...progress}/>}
      {progress.isComplete && <ChangelogsSummary/>}
    </div>
  );
};
